<div class="flex flex-wrap items-center gap-3 min-h-7">
  @if (!loading()) {
    @for (statusOption of statusOptions(); track statusOption.key) {
      @let isSelected = selectedStatuses().has(statusOption.key);

      <button
        mat-flat-button
        type="button"
        color="secondary-gray-border"
        class="deliverables-status-button [&.is-selected:not(:hover)]:!bg-[var(--status-selected-bg)]"
        [class.mat-tiny-button]="!isSelected"
        [class.mat-tiny-plus-button]="isSelected"
        [class.is-selected]="isSelected"
        [disabled]="statusOption.isDisabled"
        [style.--status-selected-bg]="isSelected ? statusBadge.currentBackgroundColor() : null"
        [style.borderColor]="isSelected ? statusBadge.currentTextColor() : 'var(--shikenso-purple-base-12)'"
        (click)="onToggleStatus(statusOption.key)"
      >
        <div class="flex items-center gap-1">
          <app-status-badge
            #statusBadge
            size="small"
            [hasBackground]="false"
            [colorScheme]="statusOption.colorScheme"
            [status]="statusOption.status"
            [detectCurrentColors]="true"
          />
          <span class="text-[10px] font-bold text-shikenso-purple-base-60"> ({{ statusOption.count }}) </span>
        </div>
      </button>
    }

    <button mat-flat-button type="button" color="secondary-gray-border" class="mat-nano-button" (click)="onClear()">
      <div class="flex items-center">
        <app-icon src="/icons/close.svg" alt="Clear" color="var(--shikenso-purple-base-60)" [size]="12" />
        <span class="text-[10px] text-shikenso-purple-base-60">{{ 'shared.clear' | translate }}</span>
      </div>
    </button>
  } @else {
    <div class="flex items-center">
      <ngx-skeleton-loader
        class="h-6"
        [count]="loaderCount()"
        [theme]="{ width: '88px', height: '24px', 'border-radius': '100vw', 'margin-right': '12px' }"
      />
      <ngx-skeleton-loader
        class="flex h-[12px] w-[44px]"
        [theme]="{ width: '44px', height: '12px', 'border-radius': '100vw' }"
      />
    </div>
  }
</div>
